import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import { Action } from 'redux'
import { ThunkDispatch } from 'redux-thunk'

import rootReducer from '../reducers'

// Infer the RootState type from the root reducer
export type RootState = ReturnType<typeof rootReducer>

// Define AppDispatch type that includes thunk support
export type AppDispatch = ThunkDispatch<RootState, unknown, Action>

export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
